<div class="alert alert-danger" role="alert" *ngIf="isCancelledPolicy">
    <h4 class="alert-heading">Policy Cancelled</h4>
    <hr />
    <p><strong>Date:</strong> {{ policy?.cancellation?._timestamp | date:'mediumDate'}}</p>
    <p><strong>Cancelled By:</strong> {{ (cancelledBy$ | async )?.userName }}</p>
    <p><strong>Reason:</strong> {{ policy?.cancellation?.reason}}</p>
</div>